var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cursor-pointer",on:{"click":_vm.onClick}},[_c('Icon',{attrs:{"small":"","color":Number(_vm.count)>0?'success':'default',"type":"link"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }